document.addEventListener("DOMContentLoaded", function(event) {
  const mapContainerSonavio = document.querySelector("#map-sonavio");
  console.log('Plugin loaded resize')
  // Check if device is mobile
  const isMobile = window.innerWidth <= 768;
  if(mapContainerSonavio) {
    const params = {
      htmlId: 'map-sonavio',
      latitude: isMobile ? 40.2 : 40.0,
      longitude: isMobile ? -3.7 : -3.5,
      categoryId: 26,
      zoomLevel: isMobile ? 5.5 : 6.5,
      isMobile: isMobile
    }
    buildMap(params)
  }

  const mapContainerAgil = document.querySelector("#map-agil-anibal");
  if(mapContainerAgil) {
    console.log("map found")
    const params = {
      htmlId: 'map-agil-anibal',
      latitude: isMobile ? 37.6 : 37.5443,
      longitude: isMobile ? -4 : -4.7278,
      categoryId: 27,
      zoomLevel: isMobile ? 7 : 8,
      isMobile: isMobile
    }
    buildMap(params)
  }
});

const buildMap = (params) => {
  const map = L.map(params.htmlId, {
    center: [params.latitude, params.longitude],
    zoom: params.zoomLevel,
    zoomSnap: 0.5  // Allows zooming in 0.5 increments
  })

  const CartoDB_VoyagerNoLabels = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    maxZoom: 20
  }).addTo(map);

  // Handle window resize to adjust map center and zoom
  const handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    if (params.htmlId === 'map-sonavio') {
      const newCenter = isMobile ? [40.2, -3.7] : [40.0, -3.5];
      const newZoom = isMobile ? 5.5 : 6.5;
      map.setView(newCenter, newZoom);
    } else if (params.htmlId === 'map-agil-anibal') {
      const newCenter = isMobile ? [37.6, -4] : [37.5443, -4.7278];
      const newZoom = isMobile ? 7 : 8;
      map.setView(newCenter, newZoom);
    }
  };

  // Add resize listener with debounce
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 250);
  });

  const addProvincesToMap = () => {
    function style() {
      return {
          fillColor: "#7db41ec9",
          weight: 1,
          opacity: 1,
          color: 'white',
          dashArray: '3',
          fillOpacity: 0.7
      };
    }
    fetch(mapData.geojsonUrl)
      .then(response => response.json())
      .then(data => {
        L.geoJson(data, {style: style}).addTo(map);
    })
    .catch(error => {
      console.error('Error loading GeoJSON:', error);
    });
  }

  addProvincesToMap();

  // Get all ps-map-locations filtered by a taxonomy term
  const taxonomySlug = 'map-location-product';

  fetch(`/wp-json/wp/v2/ps-map-locations?${taxonomySlug}=${params.categoryId}`)
    .then(response => response.json())
    .then(locations => {
      console.log(locations);
      locations.forEach(async location => {
        console.log(location);

        let imageUrl = '';
        if (location.acf.product_field_map_icon) {
          try {
            const imageResponse = await fetch(`/wp-json/wp/v2/media/${location.acf.product_field_map_icon}`);
            const imageData = await imageResponse.json();
            imageUrl = imageData.source_url;
          } catch (error) {
            console.error('Error fetching image:', error);
          }
        }
        const factor = params.isMobile ? 0.85 : 1;
        const markerProperties = {
          coordinates: {
            lat: location.acf.latitud,
            lng: location.acf.longitud
          },
          tag: location.title.rendered,
          popupId: location.acf.popup_campo,
          popupOffset: [location.acf.popup_offset_left_right * factor, location.acf.popup_offset_top_bottom * factor],
          iconUrl: imageUrl
        }

        const onClick = (e) => {
          console.log("sowing pp", e.latlng);
          elementorProFrontend.modules.popup.showPopup( { id: markerProperties.popupId } );
        }

        console.log(markerProperties)

        // Define two icon sizes
        const normalIcon = L.icon({
          iconUrl: markerProperties.iconUrl || 'https://dev.adamaexperience.com/wp-content/uploads/2025/10/icon-pre-map.png',
          iconSize:     params.isMobile ? [20, 30] : [28, 40], // size of the icon
          shadowSize:   params.isMobile ? [40, 55] : [50, 64], // size of the shadow
          iconAnchor:   params.isMobile ? [0, 30] : [0, 40], // point of the icon which will correspond to marker's location
          shadowAnchor: params.isMobile ? [3, 55] : [4, 62],  // the same for the shadow
          popupAnchor:  params.isMobile ? [-2, -65] : [-3, -76] // point from which the popup should open relative to the iconAnchor
        });

        const largeIcon = L.icon({
          iconUrl: markerProperties.iconUrl || 'https://dev.adamaexperience.com/wp-content/uploads/2025/10/icon-pre-map.png',
          iconSize:     params.isMobile ? [30, 40] : [35, 50], // size of the icon
          shadowSize:   params.isMobile ? [40, 55] : [50, 64], // size of the shadow
          iconAnchor:   params.isMobile ? [0, 30] : [0, 50], // point of the icon which will correspond to marker's location
          shadowAnchor: params.isMobile ? [3, 55] : [4, 62],  // the same for the shadow
          popupAnchor:  params.isMobile ? [-2, -65] : [-3, -76] // point from which the popup should open relative to the iconAnchor
        });

        const marker = L.marker(markerProperties.coordinates, {icon: normalIcon}).addTo(map).on('click', (e) => onClick(e));

        const popup = L.popup({
          closeButton: false,
          closeOnClick: false,
          autoClose: false,
          offset: markerProperties.popupOffset
        })
        .setContent(markerProperties.tag).setLatLng(markerProperties.coordinates).addTo(map)

        popup.getElement().addEventListener('click', (e) => onClick(e));

        marker.on('mouseover', function(e) {
          e.target.setIcon(largeIcon);
        });

        marker.on('mouseout', function(e) {
          e.target.setIcon(normalIcon);
        });
      });


  })
  .catch(error => {
    console.error('Error:', error);
  });
}